import { Component, Input } from '@angular/core';
import { AppliedReportOptions } from 'app/core/models/report.model';


@Component({
    selector: 'app-report-applied-pharmacy-partner-option',
    templateUrl: './report-applied-pharmacy-partner-option.component.html',
    imports: []
})
export class ReportAppliedPharmacyPartnerOptionComponent {
  @Input() name = 'pharmacyPartnerNames';
  @Input() label = 'Pharmacy Partners';
  @Input() options: AppliedReportOptions;

  get values() {
    const values = this.options[this.name];
    if (values) {
      return values.join(', ');
    }
  }
}
